import React, { useCallback, useEffect, useState } from 'react';
import { Tappable, Textarea } from '@vectord/components';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import { useCreateNoteMutation } from '@courseResume/services/coursePauseRequestService';
import Form from 'components/Form';
import styles from './EditNotePopoverSection.module.scss';

function EditNotePopoverSection({ handleClose, coursePauseRequest }) {
  const [note, setNote] = useState('');
  const [isNoteEdited, setIsNoteEdited] = useState(false);
  const [createNote, { isSuccess, error, isLoading: isCreating }] =
    useCreateNoteMutation();

  const handleNoteSubmit = useCallback(
    (event) => {
      event.preventDefault();
      createNote({ requestId: coursePauseRequest?.id, note });
    },
    [createNote, note, coursePauseRequest?.id]
  );

  const handleOnChange = useCallback((event) => {
    setNote(event.target.value);
    setIsNoteEdited(true);
  }, []);

  useEffect(() => {
    if (coursePauseRequest?.note) {
      setNote(coursePauseRequest?.note?.content);
    }
  }, [coursePauseRequest]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Updated request note successfully');
      handleClose();
    }
  }, [handleClose, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in carrying out this action. Please try again later!'
      );
    }
  }, [error]);

  return (
    <Form onSubmit={handleNoteSubmit}>
      <Textarea
        className={classNames(styles.note, 'scroll')}
        value={note}
        maxRows={3}
        minRows={2}
        onChange={handleOnChange}
      />
      {isNoteEdited && (
        <Tappable
          disabled={isCreating}
          type="submit"
          component="button"
          className={styles.saveButton}
          noHighlight
        >
          Save
        </Tappable>
      )}
    </Form>
  );
}

export default EditNotePopoverSection;
